import React from 'react';
import {
  SalvButton,
  SalvModal,
  SalvRadioToggleButton,
  SalvRadioToggleGroup,
  SalvTextArea,
  Size,
} from '@salvapp/ui-components';
import { FeedbackRating } from '../../../tracking/userEventTracker';
import { Form, Formik, FormikProps } from 'formik';
import { useDispatch } from 'react-redux';
import { FormikHelpers } from 'formik/dist/types';
import { showFeedback } from '../../../feedback/feedbackReducer';
import { faFaceFrown, faFaceMeh, faFaceSmile } from '@fortawesome/pro-regular-svg-icons';

interface AiInsightRatingFormValues {
  rating: FeedbackRating;
  explanation: string;
}

interface Props {
  show: boolean;
  onHide: () => void;
  giveFeedbackForAiInsight: (rating: FeedbackRating, explanation: string) => Promise<void>;
}

const ScreeningAiInsightFeedbackModal = ({ show, onHide, giveFeedbackForAiInsight }: Props) => {
  const dispatch = useDispatch();
  const submit = async (values: AiInsightRatingFormValues, _: FormikHelpers<AiInsightRatingFormValues>) => {
    await giveFeedbackForAiInsight(values.rating, values.explanation);
    dispatch(
      showFeedback({
        message: 'Feedback sent',
        success: true,
      })
    );
    onHide();
  };

  return (
    <Formik initialValues={{ rating: FeedbackRating.GOOD, explanation: '' }} onSubmit={submit}>
      {({ values, setFieldValue }: FormikProps<AiInsightRatingFormValues>) => {
        return (
          <SalvModal show={show} onHide={onHide}>
            <Form>
              <SalvModal.Header closeButton>Salv AI Insight Feedback</SalvModal.Header>
              <SalvModal.Body>
                <SalvRadioToggleGroup
                  label={'How would you rate the accuracy of this insight?'}
                  value={values.rating}
                  onChange={async (value) => {
                    await setFieldValue('rating', value);
                  }}
                  size={Size.MEDIUM}
                  className={'m-b-16'}
                >
                  <SalvRadioToggleButton value={FeedbackRating.GOOD} label={'Good'} icon={faFaceSmile} />
                  <SalvRadioToggleButton value={FeedbackRating.OK} label={'OK'} icon={faFaceMeh} />
                  <SalvRadioToggleButton value={FeedbackRating.BAD} label={'Bad'} icon={faFaceFrown} />
                </SalvRadioToggleGroup>

                <SalvTextArea
                  label={'Explanation (optional)'}
                  value={values.explanation}
                  onChange={(value) => setFieldValue('explanation', value)}
                  size={Size.MEDIUM}
                  autoSizing
                />
              </SalvModal.Body>
              <SalvModal.Footer>
                <SalvButton label={'Submit'} type={'submit'} size={Size.MEDIUM} />
              </SalvModal.Footer>
            </Form>
          </SalvModal>
        );
      }}
    </Formik>
  );
};

export default ScreeningAiInsightFeedbackModal;
